<template>
  <section>
    <gs-header title="Quản lý bảng giá">
      <router-link :to="{ name: 'create-price-table' }" class="ui mini blue button"><i class="fa fa-plus"></i> Thêm
        mới</router-link>
    </gs-header>
    <div class="padding-sm-all">
      <gs-table :ref="priceTables" :table-name="priceTables" data-source="price-tables" :data-params="filters"
        :data-sorted="sorted" :data-sorts="sorts" @remove-filter="removeFilter">
        <section slot="filters">
          <el-row :gutter="10">
            <el-col :span="4">
              <el-select class="display-block " v-model="filters.carrier_id" @change="filter" filterable
                placeholder="Chọn hãng vận chuyển">
                <el-option v-for="carrier in carriers" :key="carrier.id" :label="carrier.name" :value="carrier.id">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="4">
              <el-select class="display-block " v-model="filters.service_id" @change="filter" filterable
                placeholder="Chọn dịch vụ">
                <el-option v-for="service in services" :key="service.id" :label="service.name" :value="service.id">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="4">
              <div class="block">
                <el-date-picker class="width-100" v-model="filterDateRange" type="daterange" range-separator=" / "
                  @input="updateFilters" format="dd-MM-yyyy" placeholder="Chọn ngày">
                </el-date-picker>
              </div>
            </el-col>
            <el-col :span="4">
              <el-select class="display-block " v-model="filters.city_id" @change="filter" filterable
                placeholder="Chọn TP đi">
                <el-option v-for="city in cities" :key="city.id" :label="city.name" :value="city.id">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="4">
              <el-select class="display-block " v-model="filters.region_id" @change="filter" filterable
                placeholder="Chọn vùng miền đến">
                <el-option v-for="region in regions" :key="region.id" :label="region.name" :value="region.id">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="4">
              <el-select class="display-block " v-model="filters.city_to_id" @change="filter" filterable
                placeholder="Chọn TP đến">
                <el-option v-for="city in cities" :key="city.id" :label="city.name" :value="city.id">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="4">
              <select-client v-model="filters.apply_only_customer" @input="filter"
                placeholder="Gõ để tìm kiếm khách hàng" style="margin-top: 10px" />
            </el-col>
          </el-row>
        </section>
        <template slot-scope="datas">
          <el-table :data="datas.data" :row-class-name="tableRowClassName" border style="width: 100%">
            >
            <el-table-column label="#" width="80">
              <template slot-scope="scope">
                <small v-if="dataPaginations[priceTables]">{{ (scope.$index + 1) +
                  ((dataPaginations[priceTables].current_page - 1) * dataPaginations[priceTables].per_page)}}</small>
              </template>
            </el-table-column>

            <el-table-column label="Bảng giá">
              <template slot-scope="scope">
                <!-- <p><span class="shipment-code-display">{{scope.row.id}}</span></p> -->
                <p>
                  {{ scope.row.name }}
                </p>
                <p>
                  {{ scope.row.expected_txt }}
                </p>
                <p v-show="scope.row.hour_apply">
                  Giờ áp dụng: {{ scope.row.hour_apply_txt }}
                </p>
              </template>
            </el-table-column>

            <el-table-column label="TP đi/đến">
              <template slot-scope="scope">
                <p v-if="scope.row.city_from">
                  TP đi: {{ scope.row.city_from.data.name }}
                </p>
                <p v-if="scope.row.region_to">
                  Vùng miền đến: {{ scope.row.region_to.data.name }}
                </p>
              </template>
            </el-table-column>

            <el-table-column label="HVC">
              <template slot-scope="scope">
                <p v-if="scope.row.carrier">Tên: {{ scope.row.carrier.data.name }}</p>
                <p v-if="scope.row.service">Dịch vụ: {{ scope.row.service.data.name }}</p>
                <p>Mapping: {{ scope.row.mapping_txt }}</p>
              </template>
            </el-table-column>

            <el-table-column label="Cân nặng">
              <template slot-scope="scope">
                <p>Khởi điểm: <span class="text-orange">{{ scope.row.weight_first | gam }}</span></p>
                <p>Tối đa: <span class="text-orange">{{ scope.row.maximum_weight | gam }}</span></p>
                <p>Bước nhảy: <span class="text-orange">{{ scope.row.weight_step | gam }}</span></p>
                <p>Phí bước nhảy: <span class="text-red">{{ scope.row.weight_step_fee | vnd }}</span></p>
              </template>
            </el-table-column>

            <el-table-column label="Phí">
              <template slot-scope="scope">
                <p>Giá: <span class="text-red">{{ scope.row.amount | vnd }}</span></p>
                <p>Chuyển hoàn: <span class="text-red">{{ scope.row.return_fee | number(3) }}
                    {{ priceTableHelpers.currencies[localPriceTable.return_unit] }}</span></p>
                <p>Phụ phí ngoại thành: <span class="text-red">{{ scope.row.location_step_fee | vnd }}</span></p>
                <p>Áp dụng:
                  <el-tooltip placement="top" content="Kiểu áp dụng phụ phí ngoại thành" class="display-inline">
                    <span>{{ scope.row.lsf_type_txt }}</span>
                  </el-tooltip>
                </p>
              </template>
            </el-table-column>

            <el-table-column label="COD">
              <template slot-scope="scope">
                <p>Phí COD: <span class="text-red">{{ scope.row.cod_fee | number(3) }} %</span></p>
                <p>Phí COD tối thiểu: <span class="text-red">{{ scope.row.cod_min_fee | vnd }}</span></p>
                <p>GTĐH áp dụng: <span class="text-red">{{ scope.row.cod_apply | vnd }}</span></p>
              </template>
            </el-table-column>

            <el-table-column width="95">
              <template slot-scope="scope">
                <section class="padding-sm-top padding-sm-bottom">
                  <el-tooltip placement="top" content="Sửa" class="display-inline" v-if="!scope.row.deleted_at">
                    <router-link class="text-orange padding-all display-inline-block"
                      :to="{ name: 'edit-price-table', params: { id: scope.row.id } }"><i class="fa fa-pencil-square-o"
                        aria-hidden="true"></i></router-link>
                  </el-tooltip>
                  <el-tooltip placement="top" content="Xóa" class="display-inline" v-if="!scope.row.deleted_at">
                    <a @click.prevent="deletePriceTable(scope.row)"
                      class="text-red padding-all display-inline-block cursor-pointer"><i class="fa fa-trash"></i></a>
                  </el-tooltip>
                  <el-tooltip placement="top" content="Nhân bản" class="display-inline" v-if="!scope.row.deleted_at">
                    <router-link class="text-violet padding-all display-inline-block"
                      :to="{ name: 'copy-price-table', params: { id: scope.row.id } }"><i class="fa fa-files-o"
                        aria-hidden="true"></i></router-link>
                  </el-tooltip>
                  <el-tooltip placement="top" content="Chặn tuyến đường" class="display-inline"
                    v-if="!scope.row.deleted_at">
                    <a class="text-brown padding-all display-inline-block cursor-pointer"><i class="fa fa-road"
                        aria-hidden="true" @click.prevent="filterBlock(scope.row)"></i></a>
                  </el-tooltip>
                  <el-tooltip placement="top" content="Khôi phục" class="display-inline" v-if="scope.row.deleted_at">
                    <a class="text-blue padding-all display-inline-block cursor-pointer" @click="restore(scope.row)"><i
                        class="fa fa-refresh" aria-hidden="true"></i></a>
                  </el-tooltip>
                </section>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </gs-table>
    </div>
  </section>
</template>

<script>
import ls from 'local-storage'
import { mapGetters, mapActions } from 'vuex'
import { debounce, keys, forEach } from 'lodash'
import { deletePriceTable, restorePriceTable } from 'src/api/pricetable'
import { formatDate } from 'src/helpers'
import mixins from './mixins'
import SelectClient from 'src/components/client/SelectClient'
export default {
  name: 'PriceTable',
  mixins: [mixins],
  components: { SelectClient },
  data() {
    return {
      priceTables: 'priceTables',
      filterDateRange: '',
      filters: {
        sort: 'created_at:-1',
        carrier_id: '',
        service_id: '',
        start_date: '',
        end_date: '',
        city_id: '',
        region_id: '',
        city_to_id: '',
        apply_only_customer: '',
        include: 'carrier,service,city_from,region_to'
      },
      sorted: {
        created_at: -1,
        amount: ''
      },
      sorts: [
        { key: 'created_at', name: 'Ngày tạo' },
        { key: 'amount', name: 'Giá' }
      ]
    }
  },
  computed: {
    ...mapGetters('priceTable', ['priceTable'])
  },
  methods: {
    ...mapActions('priceTable', ['setPriceTable']),
    filter: debounce(function () {
      let lsFilter = ls.get('filters', {})
      if (!lsFilter) {
        lsFilter = {}
      }
      lsFilter[this.priceTables] = this.filters
      ls.set('filters', lsFilter)
      if (ls.get('doFilter')) {
        this.reloadGsTable(this.priceTables)
      }
    }, 300),
    removeFilter() {
      if (!this.checkDefaultFilter({
        sort: 'created_at:-1',
        carrier_id: '',
        service_id: '',
        start_date: '',
        end_date: '',
        city_id: '',
        region_id: '',
        city_to_id: '',
        apply_only_customer: '',
        include: 'carrier,service,city_from,region_to'
      })) {
        this.reloadGsTable(this.priceTables)
      }
      this.filterDateRange = ''
      this.filters = {
        sort: 'created_at:-1',
        carrier_id: '',
        service_id: '',
        start_date: '',
        end_date: '',
        city_id: '',
        region_id: '',
        city_to_id: '',
        apply_only_customer: '',
        include: 'carrier,service,city_from,region_to'
      }
    },
    checkDefaultFilter(filters) {
      let diff = false
      let lkeys = keys(filters)
      forEach(lkeys, key => {
        if (filters[key] !== this.filters[key]) {
          this.diff = true
        }
      })
      return diff
    },
    updateFilters(data) {
      this.filters.start_date = formatDate(data[0])
      this.filters.end_date = formatDate(data[1])
      this.filter()
    },
    deletePriceTable(priceTable) {
      this.setPriceTable(priceTable)
      this.$confirm(`Bạn chắc chắn muốn xóa bảng giá ${this.priceTable.name}`, 'Xóa bảng giá', {
        confirmButtonText: 'Xóa',
        cancelButtonText: 'Không',
        type: 'warning'
      }).then(() => {
        this.delPriceTable()
      }).catch(() => {

      })
    },
    delPriceTable() {
      deletePriceTable(this.priceTable.id).then(response => {
        if (response.code === 200) {
          this.$message({
            type: 'success',
            message: 'Xóa bảng giá thành công'
          })
          this.reloadGsTable(this.priceTables)
        } else {
          this.$message({
            type: 'error',
            message: 'Xóa bảng giá thất bại'
          })
        }
      })
    },
    tableRowClassName(row) {
      if (row.deleted_at) {
        return 'row-orange'
      }
      return null
    },
    restore(priceTable) {
      this.setPriceTable(priceTable)
      this.$confirm(`Bạn chắc chắn muốn khôi phục bảng giá ${this.priceTable.name}`, 'Khôi phục bảng giá', {
        confirmButtonText: 'Khôi phục',
        cancelButtonText: 'Không',
        type: 'warning'
      }).then(() => {
        this.resPriceTable()
      }).catch(() => {

      })
    },
    resPriceTable() {
      restorePriceTable(this.priceTable.id).then(response => {
        if (response.code === 200) {
          this.$message({
            type: 'success',
            message: 'Khôi phục bảng giá thành công'
          })
          this.reloadGsTable(this.priceTables)
        } else {
          this.$message({
            type: 'error',
            message: 'Khôi phục bảng giá thất bại'
          })
        }
      })
    },
    filterBlock(priceTable) {
      this.setPriceTable(priceTable)
      this.$router.push({ name: 'blocks', query: { priceTable: priceTable.id } })
    }
  },
  mounted() {
    if (ls.get('filters') && ls.get('filters')[this.priceTables]) {
      this.filters = ls.get('filters')[this.priceTables]
      setTimeout(() => {
        ls.set('doFilter', true)
      }, 100)
    }
    this.listenReloadGsTable()
    this.sorted = this.getSorted(this.priceTables)
  },
  beforeRouteEnter(to, from, next) {
    if (from.fullPath === '/') {
      ls.remove('filters')
      ls.set('doFilter', true)
    } else {
      if (ls.get('filters') && ls.get('filters')['priceTables']) {
        ls.set('doFilter', false)
      } else {
        ls.set('doFilter', true)
      }
    }
    next()
  }
}
</script>

<style lang="css" scoped>
.border-right {
  border-right: 1px solid #dfe6ec;
}
</style>



// WEBPACK FOOTER //
// PriceTable.vue?b018a49c